import IconPickerWithRemoveButton from 'client/components/core/Sidebar/components/Settings/components/IconPickerWithRemoveButton'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import React, {} from 'react'
import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import {
  FormFieldInterface,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { useUpdateFormElementProp } from '../../hooks/use-update-form-element-prop'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'

export const FormElementFieldSettings = ({
  formEntity,
  field,
}: {
  formEntity: FormInterface
  field: FormFieldInterface
}) => {
  const updateProp = useUpdateFormElementProp(formEntity, field)

  const isMandatoryType = field.slug === ContactSlugEnum.Email
  const isOptionalType =
    field.slug === ContactSlugEnum.TaxNumber ||
    field.slug === ContactSlugEnum.CompanyName

  const isOptionalSettingAvailable = !isMandatoryType && !isOptionalType

  return (
    <>
      {field.slug !== ContactSlugEnum.Country &&
        field.slug !== ContactSlugEnum.PhoneNumber && (
          <TextInputControl
            wrapperProps={{
              labelText: 'entity_settings.field.placeholder.label',
            }}
            value={field.placeholder}
            update={updateProp('placeholder')}
            type="text"
          />
        )}
      {isOptionalSettingAvailable && (
        <CheckboxControl
          label="entity_settings.field.optional"
          tooltipText="entity_settings.field.optional_popover"
          value={field.optional}
          update={updateProp('optional')}
        />
      )}
      {field.slug !== ContactSlugEnum.Country && (
        <IconPickerWithRemoveButton
          label="entity_options.icon_picker.title"
          value={field.iconClassName}
          update={updateProp('iconClassName')}
        />
      )}
      <HtmlAttrId attrId={field.htmlAttrId} />
    </>
  )
}
